import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useSubscriptionStore, AddonsEnum } from '@/store/useSubscriptionStore';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useFeatures } from '@/composables/useFeatures';
import { useUser } from '@/modules/viewer/composables/useUser';

export const useAddon = () => {
  const { getFeature } = useFeatures();
  const subscriptionStore = useSubscriptionStore();
  const organizationStore = useOrganizationStore();
  const { trial } = storeToRefs(organizationStore);
  const { isCurrentItemOwner } = useUser();

  const hasAiAddon = computed(() => {
    return isCurrentItemOwner.value && (trial?.value || subscriptionStore.hasAddonOfType(AddonsEnum.AI_ADDON) || getFeature('viewer-ai-summary').value);
  });

  const isAiAddonTrial = computed(() => {
    return trial?.value || (!subscriptionStore.hasAddonOfType(AddonsEnum.AI_ADDON) && getFeature('viewer-ai-summary').value);
  });

  return { hasAiAddon, isAiAddonTrial };
};
